module.exports = __webpack_public_path__ + "static/media/background_3.b3a7f0c9.png";